// extracted by mini-css-extract-plugin
module.exports = {"chevron":"Arrow__chevron___2e4CQ","up":"Arrow__up___1HBlk","right":"Arrow__right___1o6C4","down":"Arrow__down___73CQB","left":"Arrow__left___2JWuu"};